/* eslint-disable max-len */
export const PROMOTIONS_CHANNEL = {
  // channel ID - must be unique per app package
  id: 'promotions',

  // Channel name. Default: empty string
  name: 'Promotions',

  // The sound to play once a push comes. Default value: 'default'
  // Values allowed:
  // 'default' - plays the default notification sound
  // 'ringtone' - plays the currently set ringtone
  // filename - the filename of the sound file located in '/res/raw' without file extension (mysound.mp3 -> mysound)
  sound: 'default',

  // Vibrate on new notification. Default value: true
  // Possible values:
  // Boolean - vibrate or not
  // Array - vibration pattern - e.g. [500, 200, 500] - milliseconds vibrate, milliseconds pause, vibrate, pause, etc.
  vibration: [300, 200, 300],

  // Whether to blink the LED
  light: true,

  // LED color in ARGB format - this example BLUE color. If set to -1, light color will be default. Default value: -1.
  lightColor: '0xFF0000FF',

  // Importance - integer from 0 to 4. Default value: 3
  // 0 - none - no sound, does not show in the shade
  // 1 - min - no sound, only shows in the shade, below the fold
  // 2 - low - no sound, shows in the shade, and potentially in the status bar
  // 3 - default - shows everywhere, makes noise, but does not visually intrude
  // 4 - high - shows everywhere, makes noise and peeks
  importance: 3,

  // Show badge over app icon when non handled pushes are present. Default value: true
  badge: true,

  // Show message on locked screen. Default value: 1
  // Possible values (default 1):
  // -1 - secret - Do not reveal any part of the notification on a secure lockscreen.
  // 0 - private - Show the notification on all lockscreens, but conceal sensitive or private information on secure lockscreens.
  // 1 - public - Show the notification in its entirety on all lockscreens.
  visibility: 1,
};

export const WINNERS_CHANNEL = {
  id: 'winners',
  name: 'Winners',
  sound: 'default',
  vibration: [300, 200, 300],
  light: true,
  lightColor: '0xFF0000FF',
  importance: 4,
  badge: true,
  visibility: 1,
};



// WEBPACK FOOTER //
// ./src/store/constants/firebase.js